module.exports = __webpack_public_path__ + "static/media/megumin-les.c9f85e10.png";